import { useState, useEffect } from 'react';
import { Schedule } from '../../core/models/schedule';
import { getScheduleData } from '../../core/services/schedule.service';
import { AppointmentCalendar } from '../appointment-calendar/appointment-calendar';
import { Loading } from '../loading/loading';
import { Appointment } from '../../core/models/appointment';
import { getReservedAppointments } from '../../core/services/appointment.service';
import './frontend-wrapper.scss';
import { useTranslation } from 'react-i18next';
import { notification } from 'antd';

export const FrontEndWrapper: React.FC = () => {
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [schedule, setSchedule] = useState<Schedule[]>([]);
	const [appointmentDuration, setAppointmentDuration] = useState<number>(60);
	const [reservedAppointments, setReservedAppointments] = useState<Appointment[]>([]);

	const { t } = useTranslation();
	const [api, contextHolder] = notification.useNotification();

	/** Global global style variable */
	document.documentElement.style.setProperty('--bookr-primary-color', window.bookrPluginData.primaryColor);

	useEffect(() => {
		loadSchedule();
		loadReservedAppointments();
	}, []);

	async function loadSchedule() {
		try {
			const fetchedSchedule: Schedule[] = await getScheduleData();
			setSchedule(fetchedSchedule);
			setAppointmentDuration(Number(fetchedSchedule[0].defaultDuration));
		} catch (error) {
			console.error('Error fetching schedule data:', error);
		}
	}

	async function loadReservedAppointments(): Promise<Appointment[]> {
		let fetchedAppointments: Appointment[] = [];
		setIsLoading(true);

		try {
			fetchedAppointments = await getReservedAppointments();
			setReservedAppointments(fetchedAppointments ?? []);
		} catch (error) {
			console.error('Error fetching schedule data:', error);
		} finally {
			setIsLoading(false);
		}

		return fetchedAppointments;
	}

	async function onUpdateAppointments() {
		loadReservedAppointments().then((appointments) => {
			setReservedAppointments(appointments);

			api['success']({
				message: t('frontEnd.calendar.appointmentRequestSended'),
			});
		});
	}

	return (
		<div className='bookr-frontend-wrapper'>
			{contextHolder}
			<Loading isLoading={isLoading}>
				<AppointmentCalendar
					schedule={schedule}
					appointmentDuration={appointmentDuration}
					reservedAppointments={reservedAppointments}
					onUpdate={onUpdateAppointments}
				/>
			</Loading>
		</div>
	);
};
